const initialState = {
  Loading: false,
  isPayment: false,
  error: null,
  coupon_id: "",
}

import * as types from "./constant"

const PaymentGateway = (state = initialState, action) => {
  switch (action.type) {
    case types.initial_Payament_start:
      return {
        ...state,
        Loading: true,
      }
    case types.get_coupon_success:
      return {
        ...state,
        coupon_id: action.payload,
      }

    case types.get_coupon_fail:
      return {
        ...state,
        coupon_id: action.payload.error,
      }
    case types.get_coupon_reset:
      return {
        ...state,
        coupon_id: "",
      }

    default:
      return state
  }
}

export default PaymentGateway
